<template>
  <div>
    <v-col cols="12" md="7" offset-md="7" class="py-0"  v-if="responsive == 'PC'">
      <v-row dense>
        <v-col cols="12" sm="6" md="2" xs="3">
            <v-select class="fs-12" dense v-model="searchForm.exchange" :items="exchanges" :label="$t('common.exchange')" item-text="name" item-value="code" clearable></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-select class="fs-12" dense v-model="searchForm.symbol" :items="spotSymbols" :label="$t('common.symbol')" clearable></v-select>
        </v-col>
        <v-col cols="12" sm="5" md="2">
          <v-select class="fs-12" dense v-model="searchForm.side" :items="orderSides" :label="$t('common.side')" clearable></v-select>
        </v-col>
        <v-col cols="12" sm="5" md="2">
          <v-text-field class="fs-12" dense v-model="searchForm.spotOrderId" :label="$t('log.spotOrderId')" clearable></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <v-btn icon @click="searchSpotOrderHistory">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  
    <v-col cols="12" md="12" class="pa-0 ma-0 pa-0 px-3" v-if="responsive == 'PC'">
      <v-row dense v-if="spotLoading"> 
          <v-col cols="12">
              <v-skeleton-loader dense type="table-row-divider@30" class="mx-auto"></v-skeleton-loader>
          </v-col>
      </v-row>
      <v-data-table v-if="!spotLoading" dense hide-default-footer :headers="spotOrderHistoryHeaders" :items="spotOrderHistory"  :items-per-page="pageSize" disable-pagination>
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="(item,index) in items" :key="index">
              <td :class="CommonJS.formatExchangeColor(item.exchangeName)">{{ item.exchangeName }}</td>
              <td>{{ null == item.spotOrderId ? item.id : item.spotOrderId }}</td>
              <td>{{ null == item.exchangeOrderId ? "--" : item.exchangeOrderId }}</td>
              <td>{{ item.symbol }}</td>
              <td :class="['text-left','open_long' == item.side || 'close_buy' == item.side  ? 'green--text':'red--text']">
                <span v-side="item.side"></span>
              </td>
              <td>{{ item.orderType }}</td>
              <td class="text-right">{{ (item.side == 'open_short'|| item.side == 'close_sell') ? '-' : '' }}{{ formatNumber(item.size) }}</td>
              <td class="text-right">{{ 0 == item.price ? "--" : formatNumber(item.price.toFixed(getDecimalPlace(item.exchange, item.symbol))) }}</td>
              <td class="text-right">{{ 0 == item.takeProfitPrice ? "--" : formatNumber(item.takeProfitPrice.toFixed(getDecimalPlace(item.exchange, item.symbol))) }}</td>
              <td class="text-right">{{ 0 == item.stopLossPrice1 ? "--" : formatNumber(item.stopLossPrice1.toFixed(getDecimalPlace(item.exchange, item.symbol))) }}</td>
              <td class="text-right" :class="item.beFixedStopLossPrice ? 'grey--text' : ''">{{ 0 == item.stopLossPrice ? "--" : formatNumber(item.stopLossPrice.toFixed(getDecimalPlace(item.exchange, item.symbol))) }}</td>
              <td class="text-right" :class="item.beFixedStopLossPrice ? '' : 'grey--text'">{{ 0 == item.fixedStopLossPrice ? "--" : formatNumber(item.fixedStopLossPrice.toFixed(getDecimalPlace(item.exchange, item.symbol))) }}</td>
              <td><span v-status="item.status"></span></td>
              <td>{{ item.timestamp }}</td>
              <td :style="{color: getColorByStrategy(item.strategy)}">{{ item.strategy }}</td>
              <td :class="item.bgColor">{{ item.category }}</td>
            </tr>
            <tr v-if="spotOrderHistoryTotalElements == 0">
              <td class="text-center" colspan="17">{{ $t('log.noDataAvailable')}}</td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-divider v-if="!spotLoading"></v-divider>
      <v-row class="pb-5" v-if="spotOrderHistoryTotalElements > 0">
        <v-col cols="auto" class="ml-0 pl-0">
          <v-pagination color="lightred" :items-per-page="pageSize" circle prev-icon="mdi-menu-left" next-icon="mdi-menu-right"  v-model="spotOrderHistoryPageNo" :length="spotOrderHistoryTotalPage" :total-visible="15" @input="getSpotOrderHistoryByPages" class="ml-2 mt-3"></v-pagination>
        </v-col>
        <v-col cols="auto" class="mt-5 pt-5">
          {{$t("log.totalNumber") + formatNumber(spotOrderHistoryTotalElements)}}
        </v-col>
         <v-spacer></v-spacer>
          <v-col cols="12" sm="6" md="3" class="text-right mt-3">
            <v-btn outlined tile class="ma-2" small @click="exPortorCurrent()" :loading="currentLoading">
              <v-icon small class="mr-2">mdi-download</v-icon>{{$t("log.downloadCurrent")}}
            </v-btn>
          </v-col>
    </v-row>
    </v-col>
  <!-- mobile -->
    <v-col cols="12" class="px-5" v-if="responsive == 'mobile'">
      <v-row dense>
        <v-col cols="12">
          <div class="d-custom-flex">
            <v-select class="fs-12 mr-5" dense v-model="searchForm.exchange" :items="exchanges" :label="$t('common.exchange')" item-text="name"
            item-value="code" clearable></v-select>
            <v-select class="fs-12" dense v-model="searchForm.symbol" :items="spotSymbols" :label="$t('common.symbol')" clearable></v-select>
          </div>
          <div class="d-custom-flex">
            <v-select class="fs-12 mr-5" dense v-model="searchForm.side" :items="orderSides" :label="$t('common.side')" clearable></v-select>
            <v-text-field class="fs-12" dense v-model="searchForm.spotOrderId" :label="$t('log.spotOrderId')" clearable></v-text-field>
            <v-btn class="float-right mt-2" x-small icon  @click="searchSpotOrderHistory">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          </div>
        </v-col>
      </v-row> 
    </v-col>
    <v-col cols="12" v-if="responsive == 'mobile'">
      <v-simple-table dense hide-default-footers> 
        <template v-slot:default>
          <thead>
              <tr>
                <th>{{$t("log.exchange")}}</th>
                <th>{{$t("log.spotOrderId")}}</th>
                <th>{{$t("log.exchangeOrderId")}}</th>
                <th>{{$t("log.symbol")}}</th>
                <th >{{$t("log.side")}}</th>
                <th>{{$t("log.type")}}</th>
                <th class="text-right">{{$t("log.size")}}</th>
                <th class="text-right">{{$t("log.price")}}</th>
                <th class="text-right">{{$t("log.profit")}}</th>
                <th class="text-right">{{$t("log.loss1")}}</th>
                <th class="text-right">{{$t("log.loss")}}</th>
                <th class="text-right">{{$t("log.fixedStopLoss")}}</th>
                <th>{{$t("log.status")}}</th>
                <th>{{$t("log.time")}}</th>
                <th>{{$t("common.strategy")}}</th>
                <th>{{$t("common.category")}}</th>
              </tr>
          </thead>
          <tbody>
            <tr v-if="spotLoading">
              <td colspan="17">
                <v-progress-linear indeterminate></v-progress-linear>
              </td>
            </tr>
            <tr v-if="spotOrderHistoryTotalElements == 0">
              <td class="text-center" colspan="17">{{ $t('log.noDataAvailable')}}</td>
            </tr>
            <tr v-for="(item,index) in spotOrderHistory" :key="index">
              <td :class="CommonJS.formatExchangeColor(item.exchangeName)">{{ item.exchangeName }}</td>
              <td>{{ null == item.spotOrderId ? item.id : item.spotOrderId }}</td>
              <td>{{ null == item.exchangeOrderId ? "--" : item.exchangeOrderId }}</td>
              <td>{{ item.symbol }}</td>
              <td :class="['text-left','open_long' == item.side || 'close_buy' == item.side  ? 'green--text':'red--text']">
                <span v-side="item.side"></span>
              </td>
              <td>{{ item.orderType }}</td>
              <td class="text-right">{{ (item.side == 'open_short'|| item.side == 'close_sell') ? '-' : '' }}{{ formatNumber(item.size) }}</td>
              <td class="text-right">{{ 0 == item.price ? "--" : formatNumber(item.price.toFixed(getDecimalPlace(item.exchange, item.symbol))) }}</td>
              <td class="text-right">{{ 0 == item.takeProfitPrice ? "--" : formatNumber(item.takeProfitPrice.toFixed(getDecimalPlace(item.exchange, item.symbol))) }}</td>
              <td class="text-right">{{ 0 == item.stopLossPrice1 ? "--" : formatNumber(item.stopLossPrice1.toFixed(getDecimalPlace(item.exchange, item.symbol))) }}</td>
              <td class="text-right" :class="item.beFixedStopLossPrice ? 'grey--text' : ''">{{ 0 == item.stopLossPrice ? "--" : formatNumber(item.stopLossPrice.toFixed(getDecimalPlace(item.exchange, item.symbol))) }}</td>
              <td class="text-right" :class="item.beFixedStopLossPrice ? '' : 'grey--text'">{{ 0 == item.fixedStopLossPrice ? "--" : formatNumber(item.fixedStopLossPrice.toFixed(getDecimalPlace(item.exchange, item.symbol))) }}</td>
              <td><span v-status="item.status"></span></td>
              <td>{{ item.timestamp }}</td>
              <td :style="{color: getColorByStrategy(item.strategy)}">{{ item.strategy }}</td>
              <td :class="item.bgColor">{{ item.category }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <v-row class="pb-5" v-if="spotOrderHistoryTotalElements > 0">
        <v-col cols="12" class="ml-0 pl-0">
          <v-pagination color="lightred" circle prev-icon="mdi-menu-left" next-icon="mdi-menu-right" v-model="spotOrderHistoryPageNo" :length="spotOrderHistoryTotalPage" :total-visible="15" @input="getSpotOrderHistoryByPages" class="ml-2 mt-3"></v-pagination>
        </v-col>
        <v-col cols="auto" class="mt-5 pt-5">
          {{$t("log.totalNumber") + formatNumber(spotOrderHistoryTotalElements)}}
        </v-col>
        <v-col cols="auto" class="float-right mt-3">
          <v-btn outlined tile class="ma-2" small @click="exPortorCurrent()" :loading="currentLoading">
            <v-icon small class="mr-2">mdi-download</v-icon>{{$t("log.downloadCurrent")}}
          </v-btn>
        </v-col>
    </v-row>
    </v-col>
  </div>
</template>

<script>
  import Vue from 'vue';
  import config from '@/config';
  import { mapGetters } from "vuex";
  import CsvExportor from "csv-exportor";

  export default {
    components: {

    },
    data() {
      return {
        spotOrderHistoryHeaders:[
          { text:this.$t("log.exchange"), sortable:false},
          { text:this.$t("log.spotOrderId"), sortable:false},
          { text:this.$t("log.exchangeOrderId"), sortable:false},
          { text:this.$t("log.symbol"), sortable:false},
          { text:this.$t("log.side"), sortable:false},
          { text:this.$t("log.type"), sortable:false},
          { text:this.$t("log.size"), sortable:false, align:'right'},
          { text:this.$t("log.price"), sortable:false, align:'right'},
          { text:this.$t("log.profit"), sortable:false, align:'right'},
          { text:this.$t("log.loss1"), sortable:false, align:'right'},
          { text:this.$t("log.loss"), sortable:false, align:'right'},
          { text:this.$t("log.fixedStopLoss"), sortable:false, align:'right'},
          { text:this.$t("log.status"), sortable:false},
          { text:this.$t("log.time"), sortable:false},
          { text:this.$t("common.strategy"), sortable:false},
          { text:this.$t("common.category"), sortable:false}
        ],
        pageSize: 30,
        spotOrderHistory: [],
        spotOrderNotes: [],
        spotOrderHistoryTotalElements: 0,
        spotOrderHistoryPageNo: 1,
        spotOrderHistoryTotalPage: 0,
        spotLoading: false,
        currentLoading:false,
        // 搜索表单
        searchForm: {
          exchange: null,
          symbol: null,
          side: null,
          spotOrderId: null,
          futuresOrderId: null,
          swapUsdtOrderId: null
        },
      }
    },
    created (){

    },

    destroyed(){

    },
    watch:{
      
    },
    mounted() {
     this.getSpotOrderHistoryByPages(1)
    },
    computed:{
      ...mapGetters(['user','exchanges','spotSymbols','spotSymbolInfos','orderSides','time','responsive','strategyColors']),
    },
    methods: {
      // 分页查询现货历史交易记录
      getSpotOrderHistoryByPages(spotOrderHistoryPageNo) {
        this.spotOrderHistory = [];
        this.spotLoading = true;
        let api = config.baseUrl + '/order/spot/private/history?pageNo=' + (spotOrderHistoryPageNo - 1) + "&pageSize=" +
          this.pageSize;
        if (this.searchForm.exchange != null && this.searchForm.exchange != '') {
          api = api + '&exchange=' + this.searchForm.exchange;
        }
        if (this.searchForm.symbol != null && this.searchForm.symbol != '') {
          api = api + '&symbol=' + this.searchForm.symbol;
        }
        if (this.searchForm.side != null && this.searchForm.side != '') {
          api = api + '&side=' + this.searchForm.side;
        }
        if (this.searchForm.spotOrderId != null && this.searchForm.spotOrderId != '') {
          api = api + '&spotOrderId=' + this.searchForm.spotOrderId;
        }
        this.$http.get(api).then(response => {
          let data = response.data;
          if (data.code == 200) {
            this.spotOrderHistory = data.result.orderList;
            this.spotOrderNotes = data.result.orderNotes;
            // 将交易所code转为名字
            for (let i = 0, len = this.spotOrderHistory.length; i < len; i++) {
              this.spotOrderHistory[i].exchangeName = this.getExchangeNameByCode(this.spotOrderHistory[i].exchange);
              this.spotOrderHistory[i].timestamp = this.formatDate(this.spotOrderHistory[i].timestamp);
              this.spotOrderHistory[i].isEditNote = false;
              for (let j = 0, notesLen = this.spotOrderNotes.length; j < notesLen; j++) {
                if (this.spotOrderHistory[i].id == this.spotOrderNotes[j].orderId) {
                  this.spotOrderHistory[i].note = this.spotOrderNotes[j].note;
                  switch (this.spotOrderNotes[j].note) {
                    case 'IOB':
                      this.spotOrderHistory[i].bgColor = 'palered--text';
                      break;
                    case 'TA':
                      this.spotOrderHistory[i].bgColor = 'palegreen--text';
                      break;
                    case 'MR':
                      this.spotOrderHistory[i].bgColor = 'paleyellow--text';
                      break;
                    case 'TP':
                      this.spotOrderHistory[i].bgColor = 'red--text';
                      break;
                    default:
                      break;
                  }
                }
              }
            }
            this.spotOrderHistoryTotalElements = data.result.totalElements;
            this.spotOrderHistoryTotalPage = Math.ceil(data.result.totalElements / this.pageSize);
            this.spotLoading = false;
          } else {
            this.spotOrderHistory = [];
            this.spotOrderHistoryTotalElements = 0;
            this.spotLoading = false;
          }
        })
      },
      // 搜索现货
      searchSpotOrderHistory() {
        this.spotOrderHistory = [];
        this.spotOrderHistoryPageNo = 1;
        this.spotOrderHistoryTotalElements = 0;
        this.spotOrderHistoryTotalPage = 0;
        this.getSpotOrderHistoryByPages(1);
      },
      // 导出当前表格
      exPortorCurrent(){
        this.currentLoading = true;
        // var heads = Object.keys(this.spotOrderHistory[0]);
        var heads = ["id","exchangeName","spotOrderId","exchangeOrderId","symbol","side","orderType","price","size","takeProfitPrice","stopLossPrice1","stopLossPrice",
          "fixedStopLossPrice","beFixedStopLossPrice","trailingStopLevel1","trailingStopLevel2","trailingStopLevel3",
          "priceLevel2","priceLevel3","strategy","category","status","timestamp","sendOrderStartTimestamp","sendOrderEndTimestamp",
          "takeProfitStartTimestamp","takeProfitEndTimestamp","stopLoss1StartTimestamp","stopLoss1EndTimestamp","stopLossStartTimestamp","stopLossEndTimestamp"
          ,"fixedStopLossStartTimestamp","fixedStopLossEndTimestamp"];
        var title = ["Id","Exchange","Spot Order Id","Exchange Order Id","Symbol","Side","Type","Price","Size","Take Profit Price","Stop Loss Price 1","Stop Loss Price",
          "Fixed Stop Loss","Be Fixed Stop Loss Price","Trailing Stop Level 1","Trailing Stop Level 2","Trailing Stop Level 3",
          "Price Level 2","Price Level 3","Strategy","Category","Status","Time","Send Order Start Time","Send Order End Time",
          "Take Profit Start Time","Take Profit End Time","Stop Loss 1 Start Time","Stop Loss 1 End Time","Stop Loss Start Time","Stop Loss End Time",
          "Fixed Stop Loss Start Time","Fixed Stop Loss End Time"];
        var body =[];
        for( var i = 0 ; i < this.spotOrderHistory.length ; i++){
          var line = [];
          // let result = heads.map(item => ({key:item, value:this.spotOrderHistory[i][item]}));
          heads.map(item=>{
            // 处理时间
            if( item.indexOf("Timestamp") != -1 ){
              if(this.spotOrderHistory[i][item] == undefined || this.spotOrderHistory[i][item] == null){
                line.push("--");
              }else if( this.spotOrderHistory[i][item] == -1 ){
                line.push("-1");
              }else if( this.spotOrderHistory[i][item] == 0 ){
                line.push("--");
              }else{
                line.push(this.formatDate(this.spotOrderHistory[i][item]));
              }
            }
            if( item.indexOf("Timestamp") == -1 ){
              // 处理无值的
              if(this.spotOrderHistory[i][item] == undefined){
                line.push("--");
              }else{
                if(this.spotOrderHistory[i][item] == 0){
                  line.push("--");
                }else{
                  // size的处理
                  if(item.indexOf("size") != -1){
                    if(this.spotOrderHistory[i]["side"] == "open_long" || this.spotOrderHistory[i]["side"] == "close_buy"){
                      line.push(this.spotOrderHistory[i][item]);
                    }else{
                      line.push("-"+this.spotOrderHistory[i][item]);
                    }
                  }else{
                    line.push(this.spotOrderHistory[i][item]);
                  }
                }
              }
            }
          })
          body.push(line);
        }
        CsvExportor.downloadCsv(body, { header: title }, 'Spot-' +this.user.username + '.csv');
        this.currentLoading = false;
      },
      // 交易所code转为交易所name
      getExchangeNameByCode(code) {
        return getExchangeNameByCode(this.exchanges, code);
      },
      // 格式化日期
      formatDate(timestamp) {
        if ('localTime' == this.time) {
          return formatTime(timestamp);
        } else {
          return formatUTCTime(timestamp);
        }
      },
      // 格式化数字
      formatNumber(num) {
        return formatNumber(num)
      },
      // 获取现货小数位
      getDecimalPlace(exchange, symbol) {
        if (exchange == null || symbol == null) {
          return 8;
        }
        let exchangeSpotSymbolInfos = this.spotSymbolInfos[exchange];
        for (let i = 0, len = exchangeSpotSymbolInfos.length; i < len; i++) {
            if (exchangeSpotSymbolInfos[i].symbol == symbol) {
                return exchangeSpotSymbolInfos[i].priceDecimalPlace;
            }
        }
        return 8;
      },
      // 根据策略查询颜色
      getColorByStrategy(strategy){
        return this.strategyColors[strategy];
      },
    }
  }

</script>

<style>

</style>
